import Vue from 'vue'
import VueRouter from 'vue-router'
import getMsg from '../views/getMsg.vue'
import getOwner from '../views/getOwner.vue'
import getVis from '../views/getVis.vue'
import getYQMsg from '../views/getYQMsg.vue'
import login from '../views/login.vue'
import population from '../views/population.vue'
import edit from '../views/edit.vue'
import record from '../views/record.vue'

Vue.use(VueRouter)

/* eslint-disable */
const routes = [
  {
    path: '/',
    redirect: { path: '/login' }

  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/population',
    name: 'population',
    component: population
  },
  {
    path: '/edit',
    name: 'edit',
    component: edit
  },
  {
    path: '/getmsg',
    name: 'getMsg',
    component: getMsg
  },
  {
    path: '/getOwner',
    name: 'getOwner',
    component: getOwner
  }, {
    path: '/getvis',
    name: 'getVis',
    component: getVis
  },


  {
    path: '/getyqmsg',
    name: 'getYQMsg',
    component: getYQMsg
  },
  {
    path: '/record',
    name: 'record',
    component:record
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
